export default __webpack_public_path__ + "static/media/profile_not_smiling.65e9fb7e.svg";